import PosthogService from '~/services/posthog/PosthogService';
import type { TInviteDropdownSource, TInviteProCategory } from './types';

export interface IExistingInviteClickedPayload {
  source: TInviteDropdownSource;
  proCategory: TInviteProCategory;
}

/**
 * Fires when the user clicks "Existing Invite" from the invite dropdown
 * Event: dental_portal:invite:existing_invite_clicked
 */
export function fireExistingInviteClicked(payload: IExistingInviteClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:invite:existing_invite_clicked', {
    source: payload.source,
    pro_category: payload.proCategory,
  });
}
